import { Component } from '@verndale/core';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      contentInner: this.el.querySelector('.page-content__inner')
    };
    this.handleMask();
  }

  addListeners() {
    window.addEventListener('resize', this.handleMask.bind(this));
  }

  handleMask() {
    this.el.style.setProperty(
      '--maskPos',
      `${(this.el.offsetHeight - this.dom.contentInner.offsetHeight) / 1.25  }px`
    );
    this.el.style.setProperty('--maskScale', 1 + this.dom.contentInner.offsetHeight / this.el.offsetHeight);
  }
}
export default Module;
